import _defineProperty from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import * as React from "react";
import DefaultLayout from "~layouts/default";
import emotionCache from "~lib/emotion-cache";
import theme from "~theme";
import { ChakraProvider, ColorModeScript } from "@chakra-ui/react";
import { CacheProvider } from "@emotion/react";

var StyleProvider = function StyleProvider(props) {
  var children = props.children;
  return /*#__PURE__*/_jsx(CacheProvider, {
    value: emotionCache,
    children: /*#__PURE__*/_jsxs(ChakraProvider, {
      resetCSS: true,
      theme: theme,
      children: [/*#__PURE__*/_jsx(ColorModeScript, {
        initialColorMode: theme.config.initialColorMode
      }), children]
    })
  });
};

export default function App(props) {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  var Component = props.Component,
      pageProps = props.pageProps;
  return /*#__PURE__*/_jsx(StyleProvider, {
    children: /*#__PURE__*/_jsx(DefaultLayout, {
      children: /*#__PURE__*/_jsx(Component, _objectSpread({}, pageProps))
    })
  });
}